import { useNavigate } from "react-router-dom";
import "../../../styles/panel/user/MySitesDashboard.css";
import { useEffect, useState, useRef } from "react";
import {
  fetchMyPendingStores,
  fetchMyStores,
  fetchPlans,
  retryPaymentOrUpdateTx,
  submitPendingStoreRequest,
} from "../../../api/storeRequest";
import { API_BASE_URL } from "../../../api/http";
import { swalSuccess, swalError, swalWarning } from "../../../utils/swalAlert";
import { checkDiscount } from "../../../api/discount";
import { formatToman } from "../../../utils/stringUtil";

function statusFromDays(d) {
  if (d <= 0) return { key: "expired", label: "منقضی‌شده" };
  if (d <= 10) return { key: "soon", label: "نزدیک به پایان" };
  return { key: "active", label: "فعال" };
}

function IconRenew() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="23 4 23 10 17 10" />
      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
    </svg>
  );
}

function IconSwap() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="17 1 21 5 17 9" />
      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
      <polyline points="7 23 3 19 7 15" />
      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
    </svg>
  );
}

function IconChevronDown({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

function IconArchive() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="21 8 21 21 3 21 3 8" />
      <rect x="1" y="3" width="22" height="5" />
      <line x1="10" y1="12" x2="14" y2="12" />
    </svg>
  );
}

function IconDocument({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <line x1="10" y1="9" x2="8" y2="9" />
    </svg>
  );
}

const Icon = ({ children, className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);
const ICONS = {
  link: (
    <>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </>
  ),
};
const CARD_NUMBER = "6104-3388-0126-4298"; // TODO: replace with the real destination card number

// TODO: these two are placeholders — wire them up to the real endpoints in
// ../../../api/storeRequest once the backend routes for plan-change exist.
async function fetchAvailablePlans() {
  // Example real implementation:
  const res = await fetchPlans();
  return res.data || [];
  // return [];
}

// TODO: این یک پیاده‌سازی موقته چون بک‌اند بررسی کد تخفیف هنوز آماده نیست.
// وقتی endpoint واقعی روی بک‌اند اضافه شد، این تابع رو با فراخوانی واقعی
// (مثلاً یه تابع جدید مثل validateDiscountCode توی ../../../api/storeRequest) جایگزین کن.
// درخواست باید دو فیلد رو به بک‌اند بفرسته: code (کد تخفیف) و store_id (سایتی که
// تغییر پلن براش انجام می‌شه). انتظار می‌ره پاسخ واقعی، علاوه بر valid/message،
// یکی از این دو رو هم برگردونه تا بشه قیمت نهایی رو محاسبه کرد:
// discount_percent (درصد) یا discount_amount (مبلغ ثابت به تومان).
async function checkDiscountCode({ code, storeId }) {
  // Example real implementation در آینده:
  // const data = new FormData();
  // data.append("code", code);
  // data.append("store_id", storeId);
  // const res = await validateDiscountCode(data);
  // return res.data; // انتظار: { valid, message, discount_percent?, discount_amount? }

  return {
    valid: false,
    message: "سرور ارور",
  };
}

// قیمت نهایی بعد از اعمال کد تخفیف معتبر رو محاسبه می‌کنه.
function getDiscountedPrice(originalPrice, discountResult) {
  if (!originalPrice || !discountResult?.valid) return originalPrice;
  if (discountResult.data.percentage) {
    return Math.max(
      0,
      Math.round(originalPrice * (1 - discountResult.data.percentage / 100)),
    );
  }
  if (discountResult.discount_amount) {
    return Math.max(0, originalPrice - discountResult.discount_amount);
  }
  return originalPrice;
}

function CustomSelect({
  id,
  value,
  onChange,
  options,
  placeholder,
  disabled,
  emptyText,
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handleClickOutside(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const selected = options.find((o) => o.value === value);

  return (
    <div
      className={`custom-select ${open ? "open" : ""} ${disabled ? "disabled" : ""}`}
      ref={wrapRef}
    >
      <button
        type="button"
        id={id}
        className="custom-select-trigger"
        onClick={() => !disabled && setOpen((o) => !o)}
        disabled={disabled}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className={selected ? "" : "custom-select-placeholder"}>
          {selected ? selected.label : placeholder}
        </span>
        <IconChevronDown
          className={`custom-select-chevron ${open ? "open" : ""}`}
        />
      </button>

      {open && (
        <ul className="custom-select-menu" role="listbox">
          {options.length === 0 ? (
            <li className="custom-select-empty">
              {emptyText || "موردی یافت نشد"}
            </li>
          ) : (
            options.map((opt) => (
              <li
                key={opt.value}
                role="option"
                aria-selected={opt.value === value}
                className={`custom-select-option ${
                  opt.value === value ? "selected" : ""
                }`}
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
              >
                {opt.label}
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
}

const formatDate = (date) => {
  if (!date) return "-";
  return new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(date));
};

export default function MySitesDashboard() {
  const [stores, setStores] = useState([]);
  const [selectedPendingStore, setSelectedPendingStore] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("gateway");
  const [txNumber, setTxNumber] = useState("");
  const [cardCopied, setCardCopied] = useState(false);

  const [showArchive, setShowArchive] = useState(true);

  const handleOpenRejectReasonModal = (store) => {
    swalWarning({
      title: "دلیل رد درخواست",
      text: store.admin_note,
    });
  };

  const [isChangePlanModalOpen, setIsChangePlanModalOpen] = useState(false);
  const [changePlanStep, setChangePlanStep] = useState("select"); // "select" | "payment"
  const [changePlanStoreId, setChangePlanStoreId] = useState("");
  const [changePlanPlanId, setChangePlanPlanId] = useState("");
  const [availablePlans, setAvailablePlans] = useState([]);
  const [isLoadingPlans, setIsLoadingPlans] = useState(false);
  const [changePlanMethod, setChangePlanMethod] = useState("gateway");
  const [changePlanTx, setChangePlanTx] = useState("");
  const [changePlanCardCopied, setChangePlanCardCopied] = useState(false);
  const [isChangePlanSubmitting, setIsChangePlanSubmitting] = useState(false);

  // فیلد کد تخفیف در مودال تغییر پلن
  const [changePlanDiscountCode, setChangePlanDiscountCode] = useState("");
  const [isCheckingDiscount, setIsCheckingDiscount] = useState(false);
  const [discountCheckResult, setDiscountCheckResult] = useState(null); // { valid: boolean, message: string }
  const handleCopyCard = async () => {
    try {
      await navigator.clipboard.writeText(CARD_NUMBER.replace(/-/g, ""));
      setCardCopied(true);
      setTimeout(() => setCardCopied(false), 1800);
    } catch (err) {
      console.error(err);
    }
  };
  const handleCopyCardChangePlan = async () => {
    try {
      await navigator.clipboard.writeText(CARD_NUMBER.replace(/-/g, ""));
      setChangePlanCardCopied(true);
      setTimeout(() => setChangePlanCardCopied(false), 1800);
    } catch (err) {
      console.error(err);
    }
  };

  // ثبت و بررسی کد تخفیف در مودال تغییر پلن
  const handleCheckDiscountCode = async () => {
    if (
      !changePlanDiscountCode.trim() ||
      !changePlanStoreId ||
      isCheckingDiscount
    )
      return;

    setIsCheckingDiscount(true);
    setDiscountCheckResult(null);

    console.log({
      code: changePlanDiscountCode.trim(),
      storeId: changePlanStoreId,
    });
    try {
      // TODO: بعد از آماده شدن بک‌اند، خروجی واقعی از اینجا میاد
      const result = await checkDiscount({
        code: changePlanDiscountCode.trim(),
        storeId: changePlanStoreId,
      });
      setDiscountCheckResult(result.data);
    } catch (error) {
      console.error(error);
      setDiscountCheckResult({
        valid: false,
        message:
          error?.response?.data?.detail ||
          error?.response?.data?.message ||
          "خطایی در بررسی کد تخفیف رخ داد.",
      });
    } finally {
      setIsCheckingDiscount(false);
    }
  };

  const loadStores = async () => {
    const [activeRes, pendingRes] = await Promise.all([
      fetchMyStores(),
      fetchMyPendingStores(),
    ]);

    const active = activeRes.data || [];

    const pending = (pendingRes.data || [])
      .filter((s) => s.status === "pending" || s.status === "rejected")
      .map((s) => ({
        id: s.id,
        store_id: `pending-${s.id}`,
        store_name: s.store_name,
        plan_name: s.plan_title || "-",
        status: s.status,
        start_date: null,
        end_date: null,
        remaining_days: null,
        payment_method: s.payment_method,
        transaction_number: s.transaction_number,
        // TODO: تطبیق بده با نام فیلد واقعی که از بک‌اند برای دلیل رد می‌آد
        admin_note: s.admin_note || null,
        _isPending: true,
      }));

    setStores([...active, ...pending]);
  };
  useEffect(() => {
    loadStores();
  }, []);
  const handleOpenPaymentModal = (store) => {
    setSelectedPendingStore(store);
    setPaymentMethod("gateway");
    setTxNumber("");
    setCardCopied(false);
    setIsModalOpen(true);
  };

  const handleClosePaymentModal = () => {
    if (isSubmitting) return;
    setIsModalOpen(false);
    setSelectedPendingStore(null);
    setPaymentMethod("gateway");
    setTxNumber("");
    setCardCopied(false);
  };

  const handlePaymentConfirm = async () => {
    if (!selectedPendingStore || isSubmitting) return;
    if (paymentMethod === "card_to_card" && !txNumber.trim()) return;

    setIsSubmitting(true);

    try {
      const payload = {
        payment_method: paymentMethod,
        transaction_number:
          paymentMethod === "card_to_card" ? txNumber.trim() : undefined,
      };

      const res = await retryPaymentOrUpdateTx(
        selectedPendingStore.id,
        payload,
      );

      if (paymentMethod === "gateway" && res?.data?.payment_url) {
        setIsModalOpen(false);
        setSelectedPendingStore(null);
        window.location.href = res.data.payment_url;
        return;
      }

      setIsModalOpen(false);
      setSelectedPendingStore(null);
      setPaymentMethod("gateway");
      setTxNumber("");

      await swalSuccess({
        title: "ثبت شد",
        text: "اطلاعات پرداخت با موفقیت ثبت و به‌روزرسانی شد.",
      });

      loadStores();
    } catch (error) {
      console.error(error);
      swalError({
        text: error?.response?.data?.detail || "خطایی در انجام عملیات رخ داد.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleOpenChangePlanModal = async () => {
    setChangePlanStep("select");
    setChangePlanStoreId("");
    setChangePlanPlanId("");
    setChangePlanMethod("gateway");
    setChangePlanTx("");
    setChangePlanCardCopied(false);
    setChangePlanDiscountCode("");
    setDiscountCheckResult(null);
    setIsChangePlanModalOpen(true);

    setIsLoadingPlans(true);
    try {
      const plans = await fetchAvailablePlans();
      setAvailablePlans(plans || []);
    } catch (err) {
      console.error(err);
      setAvailablePlans([]);
    } finally {
      setIsLoadingPlans(false);
    }
  };

  const handleCloseChangePlanModal = () => {
    if (isChangePlanSubmitting) return;
    setIsChangePlanModalOpen(false);
    setChangePlanStep("select");
    setChangePlanStoreId("");
    setChangePlanPlanId("");
    setChangePlanMethod("gateway");
    setChangePlanTx("");
    setChangePlanCardCopied(false);
    setChangePlanDiscountCode("");
    setDiscountCheckResult(null);
  };

  const handleChangePlanGoToDiscount = () => {
    if (!changePlanStoreId || !changePlanPlanId) return;

    setChangePlanStep("discount");
  };

  const handleChangePlanGoToPayment = () => {
    setChangePlanStep("payment");
  };

  const handleChangePlanConfirm = async () => {
    if (!changePlanStoreId || !changePlanPlanId || isChangePlanSubmitting)
      return;
    if (changePlanMethod === "card_to_card" && !changePlanTx.trim()) return;

    setIsChangePlanSubmitting(true);

    try {
      const data = new FormData();
      data.append("plan_id", changePlanPlanId);
      data.append("store_id", changePlanStoreId);
      data.append("payment_method", changePlanMethod);

      if (changePlanMethod === "card_to_card") {
        data.append("transaction_number", changePlanTx.trim());
      }

      // کد تخفیف فقط زمانی به سرور فرستاده می‌شه که وارد شده و در مرحله‌ی
      // قبل (discount) توسط بک‌اند معتبر تشخیص داده شده باشه.
      if (changePlanDiscountCode.trim() && discountCheckResult?.valid) {
        data.append("discount_code", changePlanDiscountCode.trim());
      }

      const res = await submitPendingStoreRequest(data);

      if (changePlanMethod === "gateway" && res?.data?.payment_url) {
        setIsChangePlanModalOpen(false);
        window.location.href = res.data.payment_url;
        return;
      }

      handleCloseChangePlanModal();

      await swalSuccess({
        title: "ثبت شد",
        text:
          changePlanMethod === "card_to_card"
            ? "درخواست شما ثبت شد و پس از بررسی واریزی حداکثر تا ۳۰ دقیقه فعال خواهد شد."
            : "درخواست تغییر پلن با موفقیت ثبت شد.",
      });

      loadStores();
    } catch (error) {
      console.error(error);
      swalError({
        text:
          error?.response?.data?.detail ||
          error?.response?.data?.transaction_number?.[0] ||
          "خطایی در انجام عملیات رخ داد.",
      });
    } finally {
      setIsChangePlanSubmitting(false);
    }
  };

  const getStatus = (status) => {
    const map = {
      active: "فعال",
      pending: "در انتظار بررسی پرداخت",
      suspended: "معلق",
      approved: "تایید شده",
      rejected: "رد شده",
    };
    return map[status] || status;
  };

  // رنگ/کلاس بج وضعیت باید از خود فیلد status (که از بک‌اند میاد) گرفته بشه،
  // نه از روزهای باقی‌مانده — چون یک فروشگاه می‌تونه suspended باشه ولی هنوز
  // روزهای باقی‌مانده‌ی مثبت داشته باشه، یا برعکس.
  const getStatusPillKey = (status) => {
    const map = {
      active: "active",
      approved: "active",
      pending: "pending",
      suspended: "suspended",
      rejected: "expired",
    };
    return map[status] || "pending";
  };

  const navigate = useNavigate();
  const counts = stores.reduce(
    (acc, s) => {
      const k =
        s.remaining_days === null
          ? "nonActive"
          : statusFromDays(s.remaining_days).key;

      acc[k]++;
      return acc;
    },
    { active: 0, soon: 0, expired: 0, nonActive: 0 },
  );
  const isExpired = (s) =>
    s.remaining_days !== null &&
    s.remaining_days !== undefined &&
    s.remaining_days <= 0;

  const mainStores = stores.filter(
    (s) => !isExpired(s) && s.status != "rejected",
  );
  const activeStore = stores.filter((s) => s.status == "active");

  const archivedStores = stores.filter(
    (s) => isExpired(s) || s.status == "rejected",
  );

  // سایت‌هایی که هم‌اکنون یک اشتراک «در انتظار بررسی پرداخت» دارند —
  // تا وضعیتشون مشخص نشه (تایید یا رد) نباید دوباره در فهرست انتخاب سایت
  // برای گرفتن اشتراک جدید نمایش داده بشن.
  const storesWithPendingPlan = new Set(
    stores.filter((s) => s.status === "pending").map((s) => String(s.store_id)),
  );

  const changePlanSelectedPlan = availablePlans.find(
    (p) => String(p.plan_id) === String(changePlanPlanId),
  );
  const changePlanFinalPrice = getDiscountedPrice(
    changePlanSelectedPlan?.price,
    discountCheckResult,
  );

  const changePlanEligibleStores = stores.filter(
    (s) =>
      !s._isPending &&
      !storesWithPendingPlan.has(String(s.store_id)) &&
      (s.status === "rejected" ||
        (s.remaining_days !== null &&
          s.remaining_days !== undefined &&
          Number(s.remaining_days) <= 10)),
  );

  return (
    <div className="msd">
      <div className="dash-header">
        <div>
          <div className="dash-title">سایت‌های من</div>
          <div className="dash-subtitle">
            مدیریت اشتراک و وضعیت تمام فروشگاه‌های شما
          </div>
        </div>
        <div className="dash-header-actions">
          <button
            className="my-site-btn-secondary"
            onClick={handleOpenChangePlanModal}
          >
            <IconSwap />
            تمدید پلن
          </button>
          <button
            className="my-site-btn-primary"
            onClick={() => navigate("/panel/user/sites-requests")}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            افزودن سایت جدید
          </button>
        </div>
      </div>

      <div className="summary-row">
        <div className="chip">
          <span className="dot total" />
          <span className="lbl">کل فروشگاه‌ها</span>
          <span className="num">{stores.length}</span>
        </div>
        <div className="chip">
          <span className="dot active" />
          <span className="lbl">فعال</span>
          <span className="num">{activeStore.length}</span>
        </div>

        <div className="chip">
          <span className="dot expired" />
          <span className="lbl">منقضی‌شده</span>
          <span className="num">{counts.expired}</span>
        </div>
        <div className="chip">
          <span className="dot expired" />
          <span className="lbl">غیر فعال</span>
          <span className="num">{counts.nonActive}</span>
        </div>
      </div>

      {/* ---- بخش اشتراک‌ها: پلن، وضعیت و بازه اشتراک به‌همراه آرشیو ---- */}
      <div className="section-block">
        <div className="table-card">
          <div className="table-scroll">
            <table className="sites-table">
              <thead>
                <tr>
                  <th>نام فروشگاه</th>
                  <th>پلن</th>
                  <th>وضعیت</th>
                  <th>شروع اشتراک</th>
                  <th>پایان اشتراک</th>
                  <th>روزهای باقی‌مانده</th>
                </tr>
              </thead>
              <tbody>
                {mainStores.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="archive-empty">
                      اشتراک فعالی وجود ندارد.
                    </td>
                  </tr>
                ) : (
                  mainStores.map((store) => {
                    const daysStatus =
                      store.remaining_days === null
                        ? { key: "pending" }
                        : statusFromDays(store.remaining_days);
                    const pillKey = getStatusPillKey(store.status);
                    return (
                      <tr key={store.store_slug || store.store_id}>
                        <td>
                          <div className="store-cell">
                            {store.logo ? (
                              <img
                                className="store-avatar"
                                src={`${API_BASE_URL}${store.logo}`}
                                alt={store.store_name || "store logo"}
                              />
                            ) : (
                              <div className="store-avatar">
                                {store.store_name?.slice(0, 2) || "ف"}
                              </div>
                            )}

                            <div className="store-name-wrap">
                              <span className="store-name">
                                {store.store_name}
                              </span>
                              {store.store_slug && (
                                <a
                                  className="store-domain-link"
                                  href={`/${store.store_slug}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <Icon>{ICONS.link}</Icon>
                                  {store.store_slug}
                                </a>
                              )}
                            </div>
                          </div>
                        </td>
                        <td>
                          <span className="plan-pill">{store.plan_name}</span>
                        </td>
                        <td>
                          <span className={`status-pill ${pillKey}`}>
                            <span className="sdot" />
                            {getStatus(store.status)}
                          </span>
                        </td>
                        <td>{formatDate(store.start_date)}</td>
                        <td>{formatDate(store.end_date)}</td>
                        <td>
                          <span className={`days-left ${daysStatus.key}`}>
                            {store.remaining_days < 0 ||
                            store.remaining_days == null
                              ? "-"
                              : `${store.remaining_days} روز`}
                          </span>
                          {store.remaining_days < 0 && (
                            <span className="days-sub">
                              {Math.abs(store.remaining_days)} روز پیش
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="table-card archive-card">
          <button
            type="button"
            className="archive-toggle"
            onClick={() => setShowArchive((v) => !v)}
          >
            <IconArchive />
            <span>آرشیو اشتراک‌های منقضی‌شده</span>
            <span className="archive-count">{archivedStores.length}</span>
            <IconChevronDown
              className={`archive-chevron ${showArchive ? "open" : ""}`}
            />
          </button>

          {showArchive && (
            <div className="table-scroll">
              {archivedStores.length === 0 ? (
                <div className="archive-empty">
                  هیچ اشتراک منقضی‌شده‌ای برای آرشیو وجود ندارد.
                </div>
              ) : (
                <table className="sites-table">
                  <thead>
                    <tr>
                      <th>نام فروشگاه</th>
                      <th>پلن</th>
                      <th>وضعیت</th>
                      <th>شروع اشتراک</th>
                      <th>پایان اشتراک</th>
                      <th>روزهای باقی‌مانده</th>
                    </tr>
                  </thead>
                  <tbody>
                    {archivedStores.map((store) => {
                      const daysStatus = statusFromDays(store.remaining_days);
                      const pillKey = getStatusPillKey(store.status);
                      return (
                        <tr key={store.store_slug || store.store_id}>
                          <td>
                            <div className="store-cell">
                              {store.logo ? (
                                <img
                                  className="store-avatar"
                                  src={`${API_BASE_URL}${store.logo}`}
                                  alt={store.store_name || "store logo"}
                                />
                              ) : (
                                <div className="store-avatar">
                                  {store.store_name?.slice(0, 2) || "ف"}
                                </div>
                              )}
                              <div className="store-name-wrap">
                                <span className="store-name">
                                  {store.store_name}
                                </span>
                                {store.store_slug && (
                                  <a
                                    className="store-domain-link"
                                    href={`/${store.store_slug}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <Icon>{ICONS.link}</Icon>
                                    {store.store_slug}
                                  </a>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className="plan-pill">{store.plan_name}</span>
                          </td>
                          <td>
                            <span className={`status-pill ${pillKey}`}>
                              <span className="sdot" />
                              {getStatus(store.status)}
                              {store.status === "rejected" && (
                                <button
                                  type="button"
                                  className="reject-reason-btn"
                                  onClick={() =>
                                    handleOpenRejectReasonModal(store)
                                  }
                                  title="مشاهده دلیل رد"
                                  aria-label="مشاهده دلیل رد"
                                >
                                  <IconDocument />
                                </button>
                              )}
                            </span>
                          </td>
                          <td>{formatDate(store.start_date)}</td>
                          <td>{formatDate(store.end_date)}</td>
                          <td>
                            <span className={`days-left ${daysStatus.key}`}>
                              -
                            </span>
                            <span className="days-sub">
                              {Math.abs(store.remaining_days)} روز پیش
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </div>
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={handleClosePaymentModal}>
          <div
            className="modal-box"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-header">
              <div>
                <div className="modal-title">تمدید اشتراک</div>
                {selectedPendingStore && (
                  <div className="modal-subtitle">
                    {selectedPendingStore.store_name}
                  </div>
                )}
              </div>
              <button
                type="button"
                className="modal-close"
                onClick={handleClosePaymentModal}
                aria-label="بستن"
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="modal-label">روش پرداخت</div>

              <label
                className={`payment-option ${
                  paymentMethod === "gateway" ? "selected" : ""
                }`}
              >
                <input
                  type="radio"
                  name="payment_method"
                  value="gateway"
                  checked={paymentMethod === "gateway"}
                  onChange={() => setPaymentMethod("gateway")}
                />
                <span className="payment-option-text">
                  <span className="payment-option-title">درگاه پرداخت</span>
                  <span className="payment-option-desc">
                    پرداخت آنلاین و آنی از طریق درگاه بانکی
                  </span>
                </span>
              </label>

              <label
                className={`payment-option ${
                  paymentMethod === "card_to_card" ? "selected" : ""
                }`}
              >
                <input
                  type="radio"
                  name="payment_method"
                  value="card_to_card"
                  checked={paymentMethod === "card_to_card"}
                  onChange={() => setPaymentMethod("card_to_card")}
                />
                <span className="payment-option-text">
                  <span className="payment-option-title">کارت به کارت</span>
                  <span className="payment-option-desc">
                    واریز مستقیم و ثبت شناسه پیگیری تراکنش
                  </span>
                </span>
              </label>

              {paymentMethod === "card_to_card" && (
                <>
                  <div className="tx-field">
                    <div className="modal-label">شماره کارت مقصد</div>
                    <div className="card-number-box">
                      <span className="card-number-text" dir="ltr">
                        {CARD_NUMBER}
                      </span>
                      <button
                        type="button"
                        className={`copy-btn ${cardCopied ? "copied" : ""}`}
                        onClick={handleCopyCard}
                      >
                        {cardCopied ? (
                          <>
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <polyline points="20 6 9 17 4 12" />
                            </svg>
                            <span>کپی شد</span>
                          </>
                        ) : (
                          <>
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <rect x="9" y="9" width="13" height="13" rx="2" />
                              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                            </svg>
                            <span>کپی</span>
                          </>
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="tx-field">
                    <label className="modal-label" htmlFor="tx-number">
                      شناسه واریز / کد پیگیری
                    </label>
                    <input
                      id="tx-number"
                      type="text"
                      className="tx-input"
                      placeholder="شناسه واریز را وارد کنید"
                      value={txNumber}
                      onChange={(e) => setTxNumber(e.target.value)}
                    />
                  </div>
                </>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="modal-btn-cancel"
                onClick={handleClosePaymentModal}
                disabled={isSubmitting}
              >
                انصراف
              </button>
              <button
                type="button"
                className="modal-btn-confirm"
                onClick={handlePaymentConfirm}
                disabled={
                  isSubmitting ||
                  (paymentMethod === "card_to_card" && !txNumber.trim())
                }
              >
                {isSubmitting ? "در حال ارسال..." : "تایید و پرداخت"}
              </button>
            </div>
          </div>
        </div>
      )}

      {isChangePlanModalOpen && (
        <div className="modal-overlay" onClick={handleCloseChangePlanModal}>
          <div
            className="modal-box"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-header">
              <div>
                <div className="modal-title">تغییر پلن</div>
                <div className="modal-subtitle">
                  {changePlanStep === "select"
                    ? "سایت و پلن جدید را انتخاب کنید"
                    : changePlanStep === "discount"
                      ? "کد تخفیف (اختیاری)"
                      : "روش پرداخت را انتخاب کنید"}
                </div>
              </div>
              <button
                type="button"
                className="modal-close"
                onClick={handleCloseChangePlanModal}
                aria-label="بستن"
              >
                ×
              </button>
            </div>

            {changePlanStep === "select" && (
              <>
                <div className="modal-body">
                  <div className="tx-field">
                    <label className="modal-label" htmlFor="change-plan-site">
                      انتخاب سایت
                    </label>
                    <CustomSelect
                      id="change-plan-site"
                      value={changePlanStoreId}
                      onChange={setChangePlanStoreId}
                      placeholder="-- یک سایت را انتخاب کنید --"
                      options={changePlanEligibleStores.map((s) => ({
                        value: String(s.store_id),
                        label: s.store_name,
                      }))}
                      emptyText="سایت واجد شرایطی برای تغییر پلن وجود ندارد"
                    />
                  </div>

                  <div className="tx-field">
                    <label className="modal-label" htmlFor="change-plan-plan">
                      انتخاب پلن جدید
                    </label>
                    <CustomSelect
                      id="change-plan-plan"
                      value={changePlanPlanId}
                      onChange={setChangePlanPlanId}
                      disabled={isLoadingPlans}
                      placeholder={
                        isLoadingPlans
                          ? "در حال بارگذاری پلن‌ها..."
                          : "-- یک پلن را انتخاب کنید --"
                      }
                      options={availablePlans.map((p) => ({
                        value: String(p.plan_id),
                        label: `${p.title}${
                          p.price ? ` — ${p.price.toLocaleString()} تومان` : ""
                        }`,
                      }))}
                      emptyText="فهرست پلن‌ها در دسترس نیست"
                    />
                    {!isLoadingPlans && availablePlans.length === 0 && (
                      <span className="days-sub">
                        فهرست پلن‌ها در دسترس نیست.
                      </span>
                    )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="modal-btn-cancel"
                    onClick={handleCloseChangePlanModal}
                  >
                    انصراف
                  </button>
                  <button
                    type="button"
                    className="modal-btn-confirm"
                    onClick={handleChangePlanGoToDiscount}
                    disabled={!changePlanStoreId || !changePlanPlanId}
                  >
                    ادامه
                  </button>
                </div>
              </>
            )}

            {changePlanStep === "discount" && (
              <>
                <div className="modal-body">
                  {/* کد تخفیف — فعلاً بک‌اند بررسی کد تخفیف آماده نیست،
                      این بخش UI و state آماده است و بعداً که endpoint اضافه شد
                      باید تابع checkDiscountCode بالای فایل با فراخوانی واقعی
                      جایگزین بشه و همچنین discount_code هنگام ارسال فرم
                      (در handleChangePlanConfirm) به FormData اضافه بشه. */}
                  <div className="tx-field discount-code-field">
                    <label
                      className="modal-label"
                      htmlFor="change-plan-discount-code"
                    >
                      کد تخفیف (اختیاری)
                    </label>
                    <div className="discount-code-row">
                      <input
                        id="change-plan-discount-code"
                        type="text"
                        className="tx-input"
                        placeholder="کد تخفیف را وارد کنید"
                        value={changePlanDiscountCode}
                        onChange={(e) => {
                          setChangePlanDiscountCode(e.target.value);
                          setDiscountCheckResult(null);
                        }}
                      />
                      <button
                        type="button"
                        className="discount-code-submit-btn"
                        onClick={handleCheckDiscountCode}
                        disabled={
                          !changePlanDiscountCode.trim() || isCheckingDiscount
                        }
                      >
                        {isCheckingDiscount ? "..." : "ثبت"}
                      </button>
                    </div>

                    {discountCheckResult && !discountCheckResult.valid && (
                      <span className="discount-code-message invalid">
                        {discountCheckResult.message || "کد تخفیف نامعتبر است."}
                      </span>
                    )}

                    {changePlanSelectedPlan?.price != null && (
                      <div className="price-breakdown">
                        <div className="price-breakdown-row">
                          <span className="price-breakdown-label">
                            مبلغ قبل از تخفیف
                          </span>
                          <span className="price-breakdown-value">
                            {Number(
                              changePlanSelectedPlan.price,
                            ).toLocaleString()}{" "}
                            تومان
                          </span>
                        </div>
                        <div className="price-breakdown-row">
                          <span className="price-breakdown-label">
                            مبلغ بعد از تخفیف
                          </span>
                          <span
                            className={`price-breakdown-value ${
                              discountCheckResult?.valid ? "highlight" : ""
                            }`}
                          >
                            {Number(changePlanFinalPrice).toLocaleString()}{" "}
                            تومان
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="modal-btn-cancel"
                    onClick={() => setChangePlanStep("select")}
                  >
                    بازگشت
                  </button>
                  <button
                    type="button"
                    className="modal-btn-confirm"
                    onClick={handleChangePlanGoToPayment}
                  >
                    ادامه به پرداخت
                  </button>
                </div>
              </>
            )}

            {changePlanStep === "payment" && (
              <>
                <div className="modal-body">
                  {changePlanFinalPrice != null && (
                    <div className="payable-amount">
                      <span className="payable-amount-label">
                        مبلغ قابل پرداخت
                      </span>
                      <span className="payable-amount-value">
                        {Number(changePlanFinalPrice).toLocaleString()} تومان
                      </span>
                    </div>
                  )}

                  <div className="modal-label">روش پرداخت</div>

                  <label
                    className={`payment-option ${
                      changePlanMethod === "gateway" ? "selected" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name="change_plan_payment_method"
                      value="gateway"
                      checked={changePlanMethod === "gateway"}
                      onChange={() => setChangePlanMethod("gateway")}
                    />
                    <span className="payment-option-text">
                      <span className="payment-option-title">درگاه پرداخت</span>
                      <span className="payment-option-desc">
                        پرداخت آنلاین و آنی از طریق درگاه بانکی
                      </span>
                    </span>
                  </label>

                  <label
                    className={`payment-option ${
                      changePlanMethod === "card_to_card" ? "selected" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name="change_plan_payment_method"
                      value="card_to_card"
                      checked={changePlanMethod === "card_to_card"}
                      onChange={() => setChangePlanMethod("card_to_card")}
                    />
                    <span className="payment-option-text">
                      <span className="payment-option-title">کارت به کارت</span>
                      <span className="payment-option-desc">
                        واریز مستقیم و ثبت شناسه پیگیری تراکنش
                      </span>
                    </span>
                  </label>

                  {changePlanMethod === "card_to_card" && (
                    <>
                      <div className="tx-field">
                        <div className="modal-label">شماره کارت مقصد</div>
                        <div className="card-number-box">
                          <span className="card-number-text" dir="ltr">
                            {CARD_NUMBER}
                          </span>
                          <button
                            type="button"
                            className={`copy-btn ${
                              changePlanCardCopied ? "copied" : ""
                            }`}
                            onClick={handleCopyCardChangePlan}
                          >
                            {changePlanCardCopied ? (
                              <>
                                <svg
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <polyline points="20 6 9 17 4 12" />
                                </svg>
                                <span>کپی شد</span>
                              </>
                            ) : (
                              <>
                                <svg
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <rect
                                    x="9"
                                    y="9"
                                    width="13"
                                    height="13"
                                    rx="2"
                                  />
                                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                </svg>
                                <span>کپی</span>
                              </>
                            )}
                          </button>
                        </div>
                      </div>

                      <div className="tx-field">
                        <label
                          className="modal-label"
                          htmlFor="change-plan-tx-number"
                        >
                          شناسه واریز / کد پیگیری
                        </label>
                        <input
                          id="change-plan-tx-number"
                          type="text"
                          className="tx-input"
                          placeholder="شناسه واریز را وارد کنید"
                          value={changePlanTx}
                          onChange={(e) => setChangePlanTx(e.target.value)}
                        />
                      </div>
                    </>
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="modal-btn-cancel"
                    onClick={() => setChangePlanStep("discount")}
                    disabled={isChangePlanSubmitting}
                  >
                    بازگشت
                  </button>
                  <button
                    type="button"
                    className="modal-btn-confirm"
                    onClick={handleChangePlanConfirm}
                    disabled={
                      isChangePlanSubmitting ||
                      (changePlanMethod === "card_to_card" &&
                        !changePlanTx.trim())
                    }
                  >
                    {isChangePlanSubmitting
                      ? "در حال ارسال..."
                      : "تایید و پرداخت"}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {/* 
      {isRejectReasonModalOpen && (
        <div className="modal-overlay" onClick={handleCloseRejectReasonModal}>
          <div
            className="modal-box"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-header">
              <div>
                <div className="modal-title">دلیل رد درخواست</div>
                {rejectReasonStore && (
                  <div className="modal-subtitle">
                    {rejectReasonStore.store_name}
                  </div>
                )}
              </div>
              <button
                type="button"
                className="modal-close"
                onClick={handleCloseRejectReasonModal}
                aria-label="بستن"
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="reject-reason-box">
                {rejectReasonStore?.admin_note ||
                  "دلیلی توسط ادمین ثبت نشده است."}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="modal-btn-cancel"
                onClick={handleCloseRejectReasonModal}
              >
                بستن
              </button>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
}
